export default "__VITE_ASSET__388c6768__"